import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";

const ItemCard = ({ item, user }) => {
  const navigate = useNavigate();

  const roles = Array.isArray(user?.role)
    ? user.role
    : [user?.role].filter(Boolean);

  const handleClick = () => {
    if (item.disabled) return;

    const role = roles.find((r) => item.routes?.[r]);
    let route = item.routes?.[role];

    if (route?.includes(":userId")) {
      route = route.replace(":userId", user.user_id);
    }

    if (route) navigate(route);
  };

  const Icon = item.icon;
  const isLocked = item.disabled;

  return (
    <div
      onClick={handleClick}
      className={`relative rounded-xl shadow-md p-4 flex flex-col items-center justify-center text-center transition-all
        ${
          isLocked
            ? "bg-blue-100 cursor-not-allowed"
            : "bg-blue-500 hover:bg-blue-600 cursor-pointer"
        }`}
    >
      {/* LOCK BADGE */}
      {isLocked && (
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-white text-blue-600 text-xs font-semibold px-2 py-1 rounded-full shadow">
          <FaLock className="text-[10px]" />
          {item.access.minPlan}
        </div>
      )}

      {/* ICON */}
      <div
        className={`text-4xl mb-2 ${
          isLocked ? "text-blue-300" : "text-white"
        }`}
      >
        {Icon && <Icon />}
      </div>

      {/* TITLE */}
      <p
        className={`font-semibold text-lg px-2 ${
          isLocked ? "text-gray-600" : "text-white"
        }`}
      >
        {item.name}
      </p>

      {/* SUBTEXT */}
      {isLocked && (
        <p className="mt-1 text-xs font-medium text-blue-700 animate-pulse">
          Upgrade to {item.access.minPlan} to unlock
        </p>
      )}
    </div>
  );
};

export default ItemCard;
